import React from "react";
import "./styles.scss";
import PropTypes from "prop-types";

const Index = ({ data, onChange, onClick }) => {
  let inputElement = null;
  inputElement = (
    <>
      <div
        className={`menu-item-wrapper  ${data.mainLayerStyles} ${data.type} ${data.size}`}
      >
        {data.menuName}
      </div>
    </>
  );
  return <>{inputElement}</>;
};
Index.propTypes = {
  type: PropTypes.string,
  size: PropTypes.string,
};

Index.defaultdata = {
  type: "default",
  size: "sm",
};

export default Index;
